export default "__VITE_ASSET__BCM9D8lB__"